<template>

    <div class="text-center" v-if="$apollo.queries.readTeamMembers.loading">
        Loading...
    </div>
    <div v-else>
        <div class="flex justify-center flex-row flex-wrap">
            <div v-for="(member, index) in readTeamMembers.nodes" class="flex flex-col w-full md:w-1/2 lg:w-1/4 mb-4 md:p-4 relative group">
                <div class="rounded-[--border-radius] overflow-hidden mb-2 relative">
                    <img v-if="member.imageDisplayMediumSize" width="100%" :src="member.imageDisplayMediumSize" />
                    <img v-else width="100%" :src="defaultImage" />
                    <div class="flex items-center justify-center invisible group-hover:visible absolute top-0 left-0 w-full h-full before:absolute before:w-full before:h-full before:bg-main-rgb before:opacity-50">
                        <button @click="setViewedMember" popovertarget="member-bio" :data-index="index" class="z-[1] font-bold text-[16px] py-[16px] px-[30px] bg-main-rgb rounded-[8px]">Read bio</button>
                    </div>
                </div>
                <p class="mb-2">
                    <span class="font-bold text-[22px]">{{ member.name }}</span>
                </p>
                <p>
                    <span class="py-[4px] px-[10px] font-bold uppercase rounded-[15px] bg-main-rgb">{{ member.jobTitle }}</span>
                </p>
            </div>
        </div>

        <div popover id="member-bio" class="fixed w-full h-full top-0 left-0">
            <div class="w-full h-full bg-dark-rgb flex justify-center items-center p-[20px]">
                <div class="w-full lg:w-2/3 p-[20px] bg-light-rgb relative rounded-[--border-radius] lg:p-[50px]">
                    <button class="absolute top-[20px] right-[20px] bg-main-rgb p-[10px] rounded-[8px] z-10" popovertarget="member-bio">
                        <span class="block ph ph-x text-[24px]"></span>
                    </button>

                    <div class="flex items-start flex-col md:flex-row lg:items-center">
                        <div class="order-1 md:hidden">
                            <h4 class="mt-0 mb-2">{{ readBioName }}</h4>
                            <span class="py-[4px] px-[10px] font-bold uppercase rounded-[15px] bg-main-rgb">{{ readBioJobTitle }}</span>
                        </div>

                        <div class="rounded-[--border-radius] overflow-hidden mt-4 md:mt-0 mb-4 md:mb-0 relative order-2 md:order-1 md:basis-[33%]">
                            <img v-if="bioImage" width="100%" :src="bioImage" />
                            <img v-else width="100%" :src="defaultImage" />
                        </div>

                        <div class="order-3 md:order-2 md:basis-[66%] md:pl-5 lg:pl-[50px]">
                            <h4 class="mt-0 md:mb-2 hidden md:block">{{ readBioName }}</h4>
                            <span class="py-[4px] px-[10px] font-bold uppercase rounded-[15px] bg-main-rgb hidden md:inline">{{ readBioJobTitle }}</span>
                            <p class="md:mt-3">{{ readBioContent }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import gql from 'graphql-tag';

export default {
    name: "TeamMembers",
    data: {
        readBioName: "",
        readBioJobTitle: "",
        readBioContent: "",
        profileImage: "",
        bioImage: ""
    },
    props: {
        defaultImage: {
            type: String,
            default: ""
        },
        panelId: {
            type: Number,
            default: 0
        },
    },
    computed: {
        panelIdInt: function () {
            return parseInt(this.panelId);
        }
    },
    methods: {
        setViewedMember: function () {
            var currentMemberIndex = event.target.dataset.index;
            var currentMember = this.readTeamMembers.nodes[currentMemberIndex];

            this.readBioName = currentMember.name;
            this.readBioJobTitle = currentMember.jobTitle;
            this.readBioContent = currentMember.description;
            this.profileImage = currentMember.imageDisplayMediumSize;
            this.bioImage = currentMember.imageTeamMemberBio;
        },
    },
    apollo: {
        readTeamMembers: {
            query: gql`
                query readTeamMember($panelId: ID!) {
                    readTeamMembers (filter: {panel: { id: { eq: $panelId } } }){
                        nodes {
                            id
                            name
                            imageDisplayMediumSize
                            imageTeamMemberBio
                            jobTitle
                            description
                        }
                    }
                }`,
            variables() {
                return {
                    panelId: this.panelIdInt
                }
            },
            fetchPolicy: 'cache-and-network'
        }
    },
    render: h => h(App),
}
</script>
